import React, { forwardRef, useContext, useState } from 'react'
import { analyticsProps } from '../commonProps'
import { fieldChange } from '@cred/react-analytics/events'
import Analytics from '@cred/react-analytics'
import { SnowplowReactContext } from '@cred/react-analytics/SnowplowContextManager'

const withAnalytics = (Field, defaultConfig = {disabled: false, events: ['onBlur']}) => {
  const FieldWithAnalytics = forwardRef(({
    inputProps = {},
    analytics: analyticsOverrides = {},
    initialValue,
    ...props
  }, ref) => {
    const analyticsContexts = useContext(SnowplowReactContext),
      analytics = { ...defaultConfig, ...analyticsOverrides },
      initialOverrideValue = analytics && analytics.data && analytics.data.value,
      [currentValue, setCurrentValue] = useState(initialOverrideValue || initialValue || inputProps.value || '')

    if (analytics && !analytics.disabled && analytics.events && analytics.events.length) {
      analytics.events.forEach(eventName => {
        const currentHandler = inputProps[eventName]

        inputProps[eventName] = (evt, ...args) => {
          if (currentHandler) {
            currentHandler(evt, ...args)
          }

          const analyticsFacade = new Analytics(fieldChange.analytics(null, analyticsContexts)),
            overrideData = analytics.data || {},
            input = evt.target

          let value = null

          if (input.type === 'checkbox') {
            value = input.checked ? 'checked' : 'unchecked'
          } else {
            value = `${analytics.format ? analytics.format(input.value, props) : input.value}`
          }

          const eventValue = overrideData.value || value || null

          if (!evt.defaultPrevented && (value !== currentValue) || input.type === 'radio') {
            evt.persist()
            setTimeout(() => {
              analyticsFacade.event({
                name: overrideData.name || props.name,
                value: props.sensitive ? null : eventValue,
                label: overrideData.label || props.label || '(no label)',
                error: overrideData.error || props.error || null
              })
            }, 0)
          }

          setCurrentValue(value)
        }
      })
    }

    return <Field inputProps={inputProps} initialValue={initialValue} {...props} ref={ref} />
  })

  FieldWithAnalytics.propTypes = {
    ...Field.propTypes,
    ...analyticsProps
  }

  FieldWithAnalytics.defaultProps = {
    ...Field.defaultProps,
    analytics: defaultConfig
  }

  return FieldWithAnalytics
}

export default withAnalytics
